import apiClient from "@services/api/apiClient.jsx";

const photoFilterApi = {
  // 포토 필터 목록 조회
  getPhotoFilters: async (params = {}) => {
    try {
      const response = await apiClient.get('/photo-filters', { params });
      return response.data;
    } catch (error) {
      console.error('포토 필터 목록 조회 실패:', error);
      throw error;
    }
  },

  // 포토 필터 상세 조회
  getPhotoFilter: async (id) => {
    try {
      const response = await apiClient.get(`/photo-filters/${id}`);
      return response.data;
    } catch (error) {
      console.error('포토 필터 상세 조회 실패:', error);
      throw error;
    }
  },

  // 포토 필터 생성 (JSON 요청)
  createPhotoFilter: async (data) => {
    try {
      const response = await apiClient.post('/photo-filters', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('포토 필터 생성 실패:', error);
      throw error;
    }
  },

  // 포토 필터 수정 (JSON 요청)
  updatePhotoFilter: async (id, data) => {
    try {
      const response = await apiClient.put(`/photo-filters/${id}`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('포토 필터 수정 실패:', error);
      throw error;
    }
  },

  // 포토 필터 삭제
  deletePhotoFilter: async (id) => {
    try {
      const response = await apiClient.delete(`/photo-filters/${id}`);
      return response.data;
    } catch (error) {
      console.error('포토 필터 삭제 실패:', error);
      throw error;
    }
  },

  // 포토 필터 일괄 삭제
  deletePhotoFilters: async (ids) => {
    try {
      const response = await apiClient.delete('/photo-filters/bulk', {
        data: ids
      });
      return response.data;
    } catch (error) {
      console.error('포토 필터 일괄 삭제 실패:', error);
      throw error;
    }
  },

  // 필터명 중복 확인
  checkFilterNameDuplicate: async (filterName, excludeId = null) => {
    try {
      const params = { filterName };
      if (excludeId) {
        params.excludeId = excludeId;
      }
      const response = await apiClient.get('/photo-filters/check-duplicate', { params });
      return response.data;
    } catch (error) {
      console.error('필터명 중복 확인 실패:', error);
      throw error;
    }
  },

  // FormData 생성 헬퍼 (사용하지 않음)
  createFormData: (data) => {
    // JSON 방식으로 변경했으므로 FormData 대신 일반 객체 반환
    return data;
  }
};

export default photoFilterApi;
